export const comments_3253774 = {"data":{"data":[],"links":{}}}